<template>
    <div class="page-container">
        <!-- Exibe um overlay com um spinner enquanto os dados estão sendo carregados -->
        <v-overlay :value="isLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <!-- Componente de edição (exibido condicionalmente com v-if) -->
        <!-- É mostrado apenas quando 'showEditarItem' é verdadeiro -->
        <Editar @fecharCardEditar="closeEditar" v-if="showEditarItem" :dados="dadosEdicao"/>

        <!-- Campo de pesquisa -->
        <div class="search-container">
            <v-text-field 
                v-model="search" 
                append-icon="mdi-magnify" 
                label="Pesquisar item" 
                outlined 
                dense 
                clearable
                hide-details 
                class="search-bar">
            </v-text-field>
        </div>

        <!-- Tabela de dados -->
        <v-data-table 
            :headers="header" 
            :items="itensMenuAll" 
            :search="search" 
            class="configuracoes-table">
            
            <!-- Exibe o índice do item na tabela -->
            <template v-slot:item.index="{ item }">
                <span> {{ itensMenuAll.indexOf(item) + 1 }}</span>
            </template>

            <!-- Verifica e exibe se 'isRota' é 1 (Sim) ou 0 (Não) -->
            <template v-slot:item.isRota="{ item }">
                <span>{{ item.isRota == 1 ? 'Sim' : 'Não' }}</span>
            </template>

            <!-- Condições similares para outras colunas da tabela -->
            <template v-slot:item.novo="{ item }">
                <span>{{ item.novo == 1 ? 'Sim' : 'Não' }}</span>
            </template>

            <template v-slot:item.validarLicenca="{ item }">
                <span>{{ item.validarLicenca == 1 ? 'Sim' : 'Não' }}</span>
            </template>

            <template v-slot:item.status="{ item }">
                <span>{{ item.status == 1 ? 'Ativo' : 'Desativado' }}</span>
            </template>

            <!-- Menu de ações para cada item (por exemplo, editar) -->
            <template v-slot:item.action="{ item }">
                <v-menu bottom origin="center center" transition="scale-transition">
                    <template v-slot:activator="{ on }">
                        <v-btn fab dark color="teal" class="action-btn" v-on="on">
                            <v-icon>menu</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <!-- Ação para editar o item -->
                        <v-list-item @click="editarItem(item)">
                            <v-icon color="green" small class="mr-2">edit</v-icon>Editar
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </v-data-table>
    </div>
</template>


<script>
import ItensMenuService from '@/services/ItensMenuService';
import Swal from 'sweetalert2'
import Editar from '../../../components/ItensMenu/Editar.vue';

export default {
    data() {
        return {
            itensMenuAll: [],
            isLoading: false,
            search: "",
            // Cabeçalhos da tabela
            header: [
                { text: "#", value: "index" },
                { text: "Descrição", value: "descricao" },
                { text: "Menu", value: "descricaoMenu" },
                { text: "Permissões", value: "niveis" },
                { text: "Actualizado por", value: "modifiedBy" },
                { text: "Data da Actualização", value: "modifiedOn" },
                { text: "Página", value: "isRota" },
                { text: "Novo", value: "novo" },
                { text: "Validar Licença", value: "validarLicenca" },
                { text: "Status", value: "status" },
                { text: "Action", value: "action" }
            ],
            showEditarItem: false,
            dadosEdicao: null
        };
    },

    components: {
        Editar
    },

    created() {
        // Carrega os itens assim que o componente é montado
        this.carregarItens();
    },

    methods: {
        async carregarItens() {
            this.isLoading = true;
            try {
                // Faz uma requisição para carregar os itens (usando um serviço)
                this.itensMenuAll = await ItensMenuService.getItensMenuAllConf();
            } catch (error) {
                // Mostra uma mensagem de erro se a requisição falhar
                Swal.fire('Informação', 'Erro ao carregar os itens!', 'error');
            } finally {
                this.isLoading = false;
            }
        },

        editarItem(item) {
            this.dadosEdicao = item;
            this.showEditarItem = true;
        },

        closeEditar(boolean) {
            // Fecha o modal de edição
            this.showEditarItem = false;
            this.dadosEdicao = null;
            // Se a edição foi concluída com sucesso, recarrega os itens
            if (boolean) {
                this.carregarItens();
            }
        }
    }
};

</script>

<style scoped>
.page-container {
    /* Define o layout principal como flexbox, centralizando itens no eixo vertical */
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    background-color: #f5f5f5;
    overflow: hidden; /* Evita rolagem desnecessária */
}

.search-container {
    width: 40%; /* Define a largura do campo de pesquisa */
    margin-bottom: 15px; /* Espaçamento entre a pesquisa e a tabela */
}

.search-bar {
    width: 100%; /* Ocupa toda a largura do contêiner pai */
}

.configuracoes-table {
    width: 95%; /* Tabela quase cheia, mas com borda */
    margin: auto; /* Centraliza horizontalmente */
    background-color: #fff;
    border-radius: 8px; /* Cantos arredondados */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Efeito de elevação visual */
}

.action-btn {
    color: white; /* Ícones de menu sempre brancos */
}

</style>
